import React, { useEffect, useState } from "react";
import { storage } from "./firebase";
import { ref, getDownloadURL } from "firebase/storage";
import { ServicesSection, AboutSection, ContactSection, AboutSectionPlayful } from "./about";
import { MdDevices } from "react-icons/md";
import { MdDownload } from "react-icons/md";
import { MdLanguage } from "react-icons/md";

import { ReactComponent as AndroidLogo } from "./assets/logos/android.svg";
import { ReactComponent as WindowsLogo } from "./assets/logos/windows.svg";
import { ReactComponent as MacLogo } from "./assets/logos/macOS.svg";
import netcomposelogo from "./assets/logos/Netcompose.png";
import backgroundImg from "./assets/images/tax.png";


function App() {
  const [downloading, setDownloading] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  const containerHeight = 270;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDownload = async (filePath, fileName) => {
    setDownloading(true);
    try {
      const fileRef = ref(storage, filePath);
      const url = await getDownloadURL(fileRef);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
      setTimeout(() => setDownloading(false), 1500);
    }
  };

  const buttonStyle = {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    backgroundColor: "#292b2f",
    color: "white",
    borderRadius: 16,
    border: "none",
    padding: "20px",
    fontSize: 20,
    width: 300,
    height: 160,
    cursor: "pointer",
    boxShadow: "0 6px 10px rgba(0,0,0,0.4)",
    transition: "background-color 0.3s",
    fontFamily: "MyCustomFont, sans-serif",
  };

  const buttonHoverStyle = {
    backgroundColor: "#3c3f46",
  };

  const buttons = [
    {
      label: "Web",
      LogoComponent: MdLanguage, // globe/world icon
      logoColor: "#A9A9A9", // dark gray (or use "#D3D3D3" for light gray)
      url: "https://netcompose.gl/admin", // redirect URL
      description: (
        <>
          Få adgang til web-adminpanelet direkte fra din browser.{" "}
          <strong>Kun for vognmænd.</strong>
        </>
      ),
    },
    {
      label: "Windows",
      LogoComponent: WindowsLogo,
      logoColor: "#0078D6",
      filePath: "updates/latest/Trafikbog-1.0.3.msi",
      fileName: "Trafikbog-1.0.3.msi",
      description: (
        <>
          Til Windows 10 og nyere. MSI-installationsfil med auto-opdatering.{" "}
          <strong>Kun for vognmænd.</strong>
        </>
      ),
    },
    {
      label: "macOS",
      LogoComponent: MacLogo,
      logoColor: "#D3D3D3",
      filePath: "updates/latest/Trafikbog-1.0.3.pkg",
      fileName: "Trafikbog-1.0.2.dmg",
      description: (
        <>
          Virker på macOS 11 Big Sur og nyere. Apple-signeret DMG-fil.{" "}
          <strong>Kun for vognmænd.</strong>
        </>
      ),
    },
    {
      label: "Android",
      LogoComponent: AndroidLogo,
      logoColor: "#3DDC84",
      filePath: "updates/latest/Trafikbog-1-0-8.apk",
      fileName: "Trafikbog-1-0-8.apk",
      description: (
        <>
          Til Android 8.1+. Installer manuelt ved at aktivere ukendte kilder. Understøtter auto-opdatering.{" "}
          <strong>Kun for chauffører.</strong>
        </>
      ),
    },
  ];

  const topContainerStyle = {
    position: "fixed",
    left: "50%",
    width: "70%",
    height: containerHeight,
    backgroundColor: "#545454",
    backgroundImage: `url(${backgroundImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    border: "2px solid #777777",
    borderRadius: 14,
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    boxSizing: "border-box",
    transformOrigin: "top center",
    transition: "top 0.5s ease, transform 0.5s ease",
    zIndex: 1000,
    top: scrolled ? `-${containerHeight + 20}px` : "50%",
    transform: scrolled
      ? "translateX(-50%) translateY(0)"
      : "translateX(-50%) translateY(-50%)",
  };

  return (
  <div
    style={{
      padding: 0,
      background: "#1e1f22", // light vertical gradient
      minHeight: "200vh",
      color: "#333", // switch text color to dark for light bg
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 30,
      fontFamily: "MyCustomFont, sans-serif",
      position: "relative",
      width: "100%",
      maxWidth: "100vw",
      overflowX: "hidden",
      boxSizing: "border-box",
    }}
  >
  {/* Hero section with centered content */}
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "62vh",
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        justifyContent: "center", // horizontal centering
        alignItems: "center",     // vertical centering
      }}
    >
      {/* Darker overlay with blur */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 0.1)", // slightly darker overlay
          backdropFilter: "blur(3px)",
          WebkitBackdropFilter: "blur(3px)",
          zIndex: 1,
        }}
      ></div>

      {/* Centered Logo, Title, and Slogan */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          zIndex: 2,
        }}
      >
        {/* Logo and Title together */}
        <div
          style={{
            display: "flex",
            flexDirection: "column", // make sure it's row for horizontal alignment
            alignItems: "center",
            gap: 6, // spacing between logo & title
            padding: "10px 20px", // 👈 add padding around the background
            // backgroundColor: "rgba(255, 255, 255, 0.2)", // semi-transparent background
            // borderRadius: 10, // 👈 rounded corners (optional)
            // backdropFilter: "blur(8px)", // 👈 apply blur
            WebkitBackdropFilter: "blur(8px)", // Safari support
            transform: "translateX(-0px)", // optional: shift left
          }}
        >
          <img
            src={netcomposelogo}
            alt="Netcompose Logo"
            style={{
              width: 70, // smaller logo
              height: "auto",
            }}
          />
          <h1
            style={{
              fontSize: 20, // smaller title
              color: "#083042",
              margin: 0,
              fontWeight: "bold",
            }}
          >
            Netcompose
          </h1>
        </div>

        {/* Slogan with extra margin above */}
        <div
          style={{
            marginTop: 20, // spacing between title & slogan
            maxWidth: "60%",
            color: "#1E1E1E",
            fontSize: 28, // larger slogan text
            fontWeight: "500",
            lineHeight: 1.3,
            backgroundColor: "rgba(60, 60, 60, 0.3)", // semi-transparent background
            padding: "12px 18px",
            borderRadius: 10, // rounded corners
            border: "1px solid rgba(200, 200, 200, 0.3)", // subtle frosted border
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1), inset 0 1px 3px rgba(255, 255, 255, 0.1)", // soft shadow + inset glow
            backdropFilter: "blur(8px)", // frosted-glass effect
            WebkitBackdropFilter: "blur(8px)", // Safari support
            display: "flex",
            alignItems: "center",
            gap: 0,
          }}
        >
          <MdDownload size={70} />
          <span>Download your digital Trafikbog HERE.</span>
        </div>
      </div>
    </div>

    <div>
        <AboutSectionPlayful />
      </div>

    {/* Spacer div to push content down so it's not hidden */}
    {/* <div style={{ height: 10, width: "100%" }} /> */}

    {/* Rest of your content */}
      <h1
        style={{
          textAlign: "center",
          fontSize: 28,
          color: "lightgray",
          display: "inline-flex", // inline-flex to size to content
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
          maxWidth: "90vw",  // responsive max width, so it doesn't overflow
          margin: "0 auto", // center block horizontally
          padding: "0 10px", // some padding on very narrow screens
          wordBreak: "break-word" // allow wrapping if super narrow
        }}
      >
        <MdDevices size={36} />
        Choose your platform
      </h1>

      <div
        style={{
          width: "75%",
          height: "4px",
          background: `
            linear-gradient(
              to right,
              rgba(30, 31, 34, 0) 0%,
              #114a2b 25%,
              #083042 75%,
              rgba(30, 31, 34, 0) 100%
            )
          `,
          borderRadius: "2px",
          marginTop: 10,
          marginBottom: 20,
        }}
      ></div>

      <div
        style={{
          display: "flex",
          flexDirection: "row", // horizontal stacking
          gap: 16, // space between buttons
          flexWrap: "wrap", // wrap to next line if needed
          justifyContent: "center", // or "center" if you want centered row
        }}
      >
        {buttons.map(
          ({ label, filePath, fileName, LogoComponent, logoColor, description, url }, i) => {
            const handleClick = async () => {
              if (label === "Web") {
                window.open(url, "_blank");
              } else if (label === "Windows") {
                const key = prompt("Enter your verification key:");
                if (!key) return;

                const secretKey = process.env.REACT_APP_VERIFICATION_KEY;

                if (key === secretKey) {
                  await handleDownload(filePath, fileName);
                  window.open(process.env.REACT_APP_USER_MANUAL, "_blank");
                } else if (key !== null) {
                  alert("Invalid verification key. Please try again.");
                }
              } else {
                await handleDownload(filePath, fileName);
                window.open(process.env.REACT_APP_USER_MANUAL, "_blank");
              }
            };

            return (
              <button
                key={i}
                onClick={handleClick}
                onMouseEnter={() => setHoverIndex(i)}
                onMouseLeave={() => setHoverIndex(null)}
                style={{
                  ...buttonStyle,
                  ...(hoverIndex === i ? buttonHoverStyle : {}),
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  opacity: label === "macOS" ? 0.6 : 1,
                  cursor: label === "macOS" ? "not-allowed" : "pointer",
                  border: "2px solid rgba(255, 255, 255, 0.08)",
                  borderRadius: "16px",
                }}
                disabled={label === "macOS"}
              >
                <LogoComponent
                  style={{
                    width: 74,
                    height: 74,
                    marginRight: 24,
                    fill: logoColor,
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "left",
                  }}
                >
                  <div
                    style={{
                      fontSize: 22,
                      fontWeight: "bold",
                      marginBottom: 4,
                    }}
                  >
                    {label}
                  </div>
                  <div
                    style={{
                      fontSize: 13,
                      color: "#ccc",
                      maxWidth: 160,
                      fontFamily: "sans-serif",
                    }}
                  >
                    {label === "macOS" ? (
                      <strong style={{ color: "#aaa" }}>Not yet available.</strong>
                    ) : (
                      description
                    )}
                  </div>
                </div>
              </button>
            );
          }
        )}
      </div>

      <div
        style={{
          width: "75%",
          height: "4px",
          background: `
            linear-gradient(
              to right,
              rgba(30, 31, 34, 0) 0%,
              #114a2b 25%,
              #083042 75%,
              rgba(30, 31, 34, 0) 100%
            )
          `,
          borderRadius: "2px",
          marginTop: 10,
          marginBottom: 20,
        }}
      ></div>

      {downloading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "#292b2f",
              padding: 30,
              borderRadius: 12,
              boxShadow: "0 0 20px rgba(0,0,0,0.8)",
              color: "white",
              fontSize: 24,
              fontWeight: "bold",
              fontFamily: "MyCustomFont, sans-serif",
            }}
          >
            Preparing download...
          </div>
        </div>
      )}

      <div style={{ alignSelf: "flex-start", width: "100%" }}>
        <ContactSection />
      </div>
    </div>
  );
}

export default App;
